import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { TaxedMoney } from "@components/containers";
import { EstimatedShipping, Thumbnail } from "@components/molecules";
import { Loader } from "@temp/@next/components/atoms";
import { useProductDetails } from "@temp/@sdk/react";
import { generateProductUrlWithAttributes } from "@temp/components/ProductDetails/utils";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import { commonMessages } from "../../../intl";
import editImg from "../../../images/edit.svg";
import removeImg from "../../../images/garbage.svg";
import { ProductListItemAttributes } from "./ProductListItemAttributes";
import ProductListItemQuantity from "./ProductListItemQuantity";

var ProductListItem = function ProductListItem(_ref) {
  var _data$translation, _data$category$transl;

  var line = _ref.line,
      remove = _ref.remove,
      _ref$readonly = _ref.readonly,
      readonly = _ref$readonly === void 0 ? false : _ref$readonly;
  var intl = useIntl();

  var _useProductDetails = useProductDetails({
    id: line.variant.product.id
  }),
      data = _useProductDetails.data,
      loading = _useProductDetails.loading;

  var productAttributesWithData = line.productAttributes.map(function (item) {
    var _attributeData$attrib;

    var attributeData = data === null || data === void 0 ? void 0 : data.attributes.find(function (attr) {
      return attr.attribute.id === item.attributeId;
    });
    var valuesData = attributeData === null || attributeData === void 0 ? void 0 : attributeData.values.filter(function (value) {
      return item.values.includes(value.name);
    });
    return {
      id: attributeData === null || attributeData === void 0 ? void 0 : attributeData.attribute.id,
      name: attributeData === null || attributeData === void 0 ? void 0 : attributeData.attribute.name,
      translatedName: attributeData === null || attributeData === void 0 ? void 0 : (_attributeData$attrib = attributeData.attribute.translation) === null || _attributeData$attrib === void 0 ? void 0 : _attributeData$attrib.name,
      values: valuesData === null || valuesData === void 0 ? void 0 : valuesData.map(function (value) {
        var _value$translation;

        return {
          name: value.name,
          translatedName: (_value$translation = value.translation) === null || _value$translation === void 0 ? void 0 : _value$translation.name
        };
      })
    };
  }) || [];
  var variantAttributesWithData = line.variant.attributes.map(function (item) {
    var _attributeData$transl;

    var attributeData = data === null || data === void 0 ? void 0 : data.productType.variantAttributes.find(function (attr) {
      return attr.id === item.attribute.id;
    });
    return {
      id: attributeData === null || attributeData === void 0 ? void 0 : attributeData.id,
      name: attributeData === null || attributeData === void 0 ? void 0 : attributeData.name,
      translatedName: attributeData === null || attributeData === void 0 ? void 0 : (_attributeData$transl = attributeData.translation) === null || _attributeData$transl === void 0 ? void 0 : _attributeData$transl.name,
      values: item.values.map(function (value) {
        var _value$translation2;

        return {
          name: value.name,
          translatedName: (_value$translation2 = value.translation) === null || _value$translation2 === void 0 ? void 0 : _value$translation2.name
        };
      })
    };
  }) || [];
  var allAttributes = useMemo(function () {
    return [].concat(_toConsumableArray(productAttributesWithData), _toConsumableArray(variantAttributesWithData));
  }, [productAttributesWithData, variantAttributesWithData]);
  var editUrl = useMemo(function () {
    var attributes = allAttributes.reduce(function (acc, cur) {
      var value = cur.values && cur.values[0];
      acc[cur.name] = value === null || value === void 0 ? void 0 : value.name;
      return acc;
    }, {});
    return generateProductUrlWithAttributes(line.variant.product, attributes);
  }, [allAttributes, line.variant.product]);

  if (loading) {
    return React.createElement(Loader, null);
  }

  if (!data) {
    return React.createElement("div", null, "no data");
  }

  return React.createElement("li", {
    className: "cart__list__item"
  }, React.createElement(Link, {
    to: editUrl,
    className: "cart__list__item-img"
  }, React.createElement(Thumbnail, {
    source: line.variant.product
  })), React.createElement("div", {
    className: "cart__list__item__details"
  }, React.createElement(Link, {
    to: editUrl,
    className: "cart__list__item-name"
  }, React.createElement("p", null, ((_data$translation = data.translation) === null || _data$translation === void 0 ? void 0 : _data$translation.name) || data.name)), line.variant.product.category && React.createElement("p", {
    className: "cart__list__item-category"
  }, React.createElement("span", {
    className: "cart__list__item-hint"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Collection: ",
    "id": "components.OverlayManager.Cart.ProductListItem.641183913"
  }, "id", "components.OverlayManager.Cart.ProductListItem.641183913"))), ((_data$category$transl = data.category.translation) === null || _data$category$transl === void 0 ? void 0 : _data$category$transl.name) || data.category.name), React.createElement(ProductListItemAttributes, {
    attributes: allAttributes
  }), React.createElement("p", {
    className: "cart__list__item-price"
  }, React.createElement(TaxedMoney, {
    taxedMoney: line.variant.pricing.price
  })), React.createElement("div", {
    className: "cart__list__item-bottom"
  }, !readonly && React.createElement(ProductListItemQuantity, {
    line: line
  }), readonly && React.createElement("div", {
    className: "cart__list__item-shipping"
  }, "".concat(intl.formatMessage(commonMessages.quantity), ": ").concat(line.quantity)), React.createElement("div", {
    className: "cart__list__item-shipping"
  }, React.createElement(EstimatedShipping, {
    productType: data.productType,
    type: "short",
    exact: true
  }))), !readonly && React.createElement("div", {
    className: "cart__list__item-actions"
  }, React.createElement(Link, {
    to: editUrl,
    className: "cart__list__item-icon"
  }, React.createElement("img", {
    src: editImg,
    alt: "edit"
  })), React.createElement(ReactSVG, {
    path: removeImg,
    className: "cart__list__item-icon",
    onClick: function onClick() {
      return remove(line.variant.product.id, line.variant.id, line.productAttributes);
    }
  }))));
};

export default ProductListItem;